export default "__VITE_ASSET__2508cc13__"